import RMTable from 'components/customComponents/Controls/RMTable';
import React, { useState } from 'react';
import DoeIngredients from './DoeIngredients';
import { SelectNameValue } from 'business/models/CustomModels';
import { cloneDeep } from 'lodash';
import { useSetMatchTableData } from './hooks';

export interface ImportDoeProps {
  doePreviewTableData: any[];
  setDoePreviewTableData: any;
  matchedIngredients: any[];
  setMatchedIngredients: any;
}

const TABLE_COLUMNS = [
  { accessor: 'name', Header: 'Imported Data', className: 'min-w-[45%]' },
  { accessor: 'matchTo', Header: 'Match to', className: 'min-w-[40%]' },
  { accessor: 'unit', Header: 'Unit' },
];

const concUnits: SelectNameValue[] = [
  {
    value: 1,
    name: '%v/v',
  },
  {
    value: 2,
    name: '%w/v',
  },
  {
    value: 3,
    name: 'mM',
  },
  {
    value: 4,
    name: 'M',
  },
  {
    value: 5,
    name: 'pH',
  },
];

const ImportDoeView = (props: ImportDoeProps) => {
  const {
    doePreviewTableData,
    setDoePreviewTableData,
    matchedIngredients,
    setMatchedIngredients,
  } = props;
  const [selectedRows, setSelectedRows] = useState([]);
  const [dataRows, setDataRows] = useState([]);
  const [selectedRowData, setSelectedRowData] = useState();
  useSetMatchTableData(doePreviewTableData, setDataRows, onCellChange);

  function onCellChange(e, headerName) {
    const tempData = cloneDeep(doePreviewTableData);
    const changedRowIndex = tempData.findIndex((x) => x.name == headerName);
    tempData[changedRowIndex].selectedUnit = concUnits.find(
      (x) => x.value == e.target.value,
    );
    setDoePreviewTableData(tempData);
  }

  const handleSelectionChange = (rowIndices) => {
    let selectedRow = null;
    if (rowIndices.length > 0) {
      selectedRow = rowIndices[rowIndices.length - 1];
      setSelectedRows([selectedRow]);
      setSelectedRowData(doePreviewTableData[selectedRow]);
    } else {
      setSelectedRows([]);
      setSelectedRowData(null);
    }
  };

  return (
    <>
      <div id='commandpanel-importdoe-importdoeview-container' className="h-[512px] flex flex-row">
        <div id='commandpanel-importdoe-importdoeview-left' className="w-[70%] flex flex-col">
          <div id='commandpanel-importdoe-importdoeview-matchdata-container' className="h-[45%]">
            <div id='commandpanel-importdoe-importdoeview-matchdata-header' className="text-[14px] font-[600] text-[#000000] h-[15%]">
              Match Imported Data
            </div>
            <div id='commandpanel-importdoe-importdoeview-matchdata-table-wrapper' className="h-[85%] w-[100%] border border-solid border-[#E0E0E0]">
              <RMTable
                data={[...dataRows]}
                columns={TABLE_COLUMNS}
                selectedIds={selectedRows}
                onCheckboxSelectionChange={handleSelectionChange}
                cellClassName="justify-start"
                selectRowOnClick={false}
                tableClass="w-[100%]"
              />
            </div>
          </div>

          <div id='commandpanel-importdoe-importdoeview-datapreview-container' className="h-[55%]">
            <div
              id='commandpanel-importdoe-importdoeview-datapreview-header'
              style={{ marginTop: '10px' }}
              className="h-[10%] text-[14px] font-[600] text-[#000000]"
            >
              Data Preview
            </div>
            <div id='commandpanel-importdoe-importdoeview-datapreview-table-wrapper' className="h-[90%] border border-solid border-[#E0E0E0] flex flex-col overflow-x-scroll">
              <div id='commandpanel-importdoe-importdoeview-datapreview-table-content' style={{ marginTop: '10px' }} className="h-[100%] w-[100%]">
                {doePreviewTableData.map((tableRow, index) => {
                  return (
                    <div id={`commandpanel-importdoe-importdoeview-datapreview-row-${index}`}
                      key={`doe-${index}`}
                      style={{ marginLeft: '18px' }}
                      className="flex flex-row h-[32px]"
                    >
                      {tableRow.values.map((rowElement, index) => {
                        if (index == 0) {
                          return (
                            <div
                              id={`commandpanel-importdoe-importdoeview-datapreview-doe1-row-${index}`}
                              key={`doe-1-${index}`}
                              className="w-[200px] text-[12px] text-[#474747] shrink-0"
                            >
                              {rowElement}
                            </div>
                          );
                        } else {
                          return (
                            <div
                              id={`commandpanel-importdoe-importdoeview-datapreview-doe2-row-${index}`}
                              key={`doe-2-${index}`}
                              className="w-[55px] text-[12px] text-[#474747] shrink-0"
                            >
                              {rowElement}
                            </div>
                          );
                        }
                      })}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>

        <div id='commandpanel-importdoe-importdoeview-right' className="w-[30%]">
          <DoeIngredients
            id='commandpanel-importdoe-importdoeview-doeingredients'
            selectedRowData={selectedRowData}
            matchedIngredients={matchedIngredients}
            setMatchedIngredients={setMatchedIngredients}
            doePreviewTableData={doePreviewTableData}
            setDoePreviewTableData={setDoePreviewTableData}
          />
        </div>
      </div>
    </>
  );
};

export default ImportDoeView;
